import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { TPrimaryColor } from '@/constants'
import { TThemeSetting } from '@/types'

export const themeSettingAtom = atomWithStorage<TThemeSetting>(
  's:themeSetting',
  window.hallway.universe.defaultThemeSetting,
  undefined,
  { getOnInit: true }
)

export const primaryColorAtom = atomWithStorage<TPrimaryColor>(
  's:primaryColor',
  window.hallway.universe.defaultPrimaryColor,
  undefined,
  { getOnInit: true }
)

const systemThemeAtom = atom<'light' | 'dark'>('light')
systemThemeAtom.onMount = (setAtom) => {
  const mq = window.matchMedia('(prefers-color-scheme: dark)')
  setAtom(mq.matches ? 'dark' : 'light')
  const handler = (e: MediaQueryListEvent) => setAtom(e.matches ? 'dark' : 'light')
  mq.addEventListener('change', handler)
  return () => mq.removeEventListener('change', handler)
}

export const avatarStyleAtom = atomWithStorage<'circle' | 'square'>(
  's:avatarStyle',
  window.hallway.universe.avatarStyleDefault ?? 'square',
  undefined,
  { getOnInit: true }
)

export const themeAtom = atom((get) => {
  const setting = get(themeSettingAtom)
  return setting === 'system' ? get(systemThemeAtom) : setting
})
